import { useEffect, useMemo, useState } from "react";
import { getSubjectConfigs } from "../../../services/apis/auditApis";

// Loads all per-workflow subject configs and derives the columns to show for a
// given app/workflow context:
//   - if wfId is given, use that workflow's config
//   - else aggregate across the app's workflows (a slot is shown if ANY of the
//     app's workflows configures it; the label is the first non-empty one)
const useSubjectConfig = (appId, wfId) => {
  const [configs, setConfigs] = useState([]);

  useEffect(() => {
    if (!appId) {
      setConfigs([]);
      return;
    }
    let cancelled = false;
    getSubjectConfigs()
      .then((response) => {
        if (!cancelled) setConfigs(response?.data || []);
      })
      .catch(() => {
        if (!cancelled) setConfigs([]);
      });
    return () => {
      cancelled = true;
    };
  }, [appId]);

  const activeColumns = useMemo(() => {
    if (!appId) return [];
    let relevant;
    if (wfId) {
      // match on app too — cloned apps share workflow ids
      relevant = configs.filter((c) => c.wf_id === wfId && c.app_id === appId);
    } else {
      relevant = configs.filter((c) => c.app_id === appId);
    }
    // per slot (1..3): shown if any relevant config has a field_id; label = first non-empty
    return [0, 1, 2]
      .map((i) => {
        const withField = relevant.find((c) => c.fields?.[i]?.field_id);
        if (!withField) return null;
        const labelled = relevant.find((c) => c.fields?.[i]?.label);
        return { idx: i + 1, label: labelled?.fields?.[i]?.label || `Subject ${i + 1}` };
      })
      .filter(Boolean);
  }, [configs, appId, wfId]);

  return { activeColumns };
};

export default useSubjectConfig;
